import { CashDocumentsRoutes } from '../../../Router/path';

export const normalizeReturnToPath = (value?: string | null): string | null => {
  if (!value || !value.startsWith('/') || value.startsWith('//')) {
    return null;
  }

  return value;
};

export const buildCashDocumentCreatePath = (
  reservationId: number,
  returnTo?: string | null
): string => {
  const params = new URLSearchParams({ reservationId: String(reservationId) });
  const normalizedReturnTo = normalizeReturnToPath(returnTo);

  if (normalizedReturnTo) {
    params.set('returnTo', normalizedReturnTo);
  }

  return `${CashDocumentsRoutes.create}?${params.toString()}`;
};

export const buildCashDocumentEditPath = (id: number, returnTo?: string | null): string => {
  const basePath = CashDocumentsRoutes.update.replace(':id', String(id));
  const normalizedReturnTo = normalizeReturnToPath(returnTo);

  if (!normalizedReturnTo) {
    return basePath;
  }

  const params = new URLSearchParams({ returnTo: normalizedReturnTo });
  return `${basePath}?${params.toString()}`;
};

export const resolveCashDocumentRedirectPath = (returnTo?: string | null): string => {
  return normalizeReturnToPath(returnTo) ?? CashDocumentsRoutes.root;
};
